"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toQueryParams = toQueryParams;
exports.fromQueryParams = fromQueryParams;
const serialization_1 = require("./serialization");
function toQueryParams(q) {
    return { q: JSON.stringify(q) };
}
function fromQueryParams(q) {
    if (!q.q) {
        return {};
    }
    let obj;
    try {
        obj = (0, serialization_1.jsonParse)(q.q);
    }
    catch (e) {
        // Try to decodeURIComponent first to support older API clients
        obj = (0, serialization_1.jsonParse)(decodeURIComponent(q.q));
    }
    return obj;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVlcnkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvcXVlcnkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFZQSxzQ0FFQztBQUVELDBDQVlDO0FBekJELG1EQUEyQztBQVMzQyxTQUFnQixhQUFhLENBQUMsQ0FBa0I7SUFDNUMsT0FBTyxFQUFFLENBQUMsRUFBRSxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUE7QUFDbkMsQ0FBQztBQUVELFNBQWdCLGVBQWUsQ0FBMEMsQ0FBOEI7SUFDbkcsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQztRQUNQLE9BQU8sRUFBRSxDQUFBO0lBQ2IsQ0FBQztJQUNELElBQUksR0FBRyxDQUFBO0lBQ1AsSUFBSSxDQUFDO1FBQ0QsR0FBRyxHQUFHLElBQUEseUJBQVMsRUFBQyxDQUFDLENBQUMsQ0FBVyxDQUFDLENBQUE7SUFDbEMsQ0FBQztJQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUM7UUFDVCwrREFBK0Q7UUFDL0QsR0FBRyxHQUFHLElBQUEseUJBQVMsRUFBQyxrQkFBa0IsQ0FBQyxDQUFDLENBQUMsQ0FBVyxDQUFDLENBQUMsQ0FBQTtJQUN0RCxDQUFDO0lBQ0QsT0FBTyxHQUF5QyxDQUFBO0FBQ3BELENBQUMifQ==